import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class SecretPage extends ModelBase {
  public static readonly type = 'SecretPage';
  public readonly type = SecretPage.type;

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('group_id')
  public groupId: string;

  @autoserializeAs('text')
  public text: string;
}
